// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__kU1NB","paramInput":"JobSimulator_paramInput__2qnyr","input":"JobSimulator_input__3I6KW"};